/* VELOURS — interacciones propias (vanilla, sin librerías) */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------
     Reveal al hacer scroll
     Regla de oro: el contenido SIEMPRE acaba visible. No depende
     de IntersectionObserver ni de requestAnimationFrame (ambos se
     congelan en pestañas que el navegador no está pintando).
     --------------------------------------------------------- */
  var revelables = [];
  var revelarProgramado = false;

  function mostrar(el) { el.classList.add('mt-visible'); }

  function revelarVisibles() {
    revelarProgramado = false;
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var quedan = false;
    revelables.forEach(function (el) {
      if (el.classList.contains('mt-visible')) return;
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.95 && r.bottom > 0) mostrar(el);
      else quedan = true;
    });
    if (!quedan) {
      window.removeEventListener('scroll', pedirRevelado);
      window.removeEventListener('resize', pedirRevelado);
    }
  }

  function pedirRevelado() {
    if (revelarProgramado) return;
    revelarProgramado = true;
    setTimeout(revelarVisibles, 60);
  }

  function initReveal() {
    var nuevos = document.querySelectorAll('.mt-reveal:not([data-mt-ready])');
    if (!nuevos.length) return;
    nuevos.forEach(function (el) {
      el.setAttribute('data-mt-ready', '1');
      if (reduce) { mostrar(el); return; }
      revelables.push(el);
    });
    if (reduce) return;
    window.addEventListener('scroll', pedirRevelado, { passive: true });
    window.addEventListener('resize', pedirRevelado, { passive: true });
    window.addEventListener('load', pedirRevelado);
    revelarVisibles();
    [120, 400, 1000, 2500].forEach(function (ms) { setTimeout(pedirRevelado, ms); });
  }

  /* ---------------------------------------------------------
     Carrusel de productos
     --------------------------------------------------------- */
  function initCarruseles() {
    document.querySelectorAll('[data-mt-carrusel]:not([data-mt-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-mt-ready', '1');
      var pista = wrap.querySelector('.mt-prod__carrusel');
      if (!pista) return;
      var id = wrap.getAttribute('data-mt-carrusel');
      var prev = document.querySelector('[data-mt-prev="' + id + '"]');
      var next = document.querySelector('[data-mt-next="' + id + '"]');

      function paso() {
        var card = pista.querySelector('.mt-card');
        if (!card) return pista.clientWidth;
        var gap = parseFloat(getComputedStyle(pista).columnGap || '16') || 16;
        return card.getBoundingClientRect().width + gap;
      }
      function estado() {
        if (!prev || !next) return;
        var max = pista.scrollWidth - pista.clientWidth - 2;
        prev.disabled = pista.scrollLeft <= 2;
        next.disabled = pista.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { pista.scrollBy({ left: -paso(), behavior: reduce ? 'auto' : 'smooth' }); setTimeout(estado, 450); });
      if (next) next.addEventListener('click', function () { pista.scrollBy({ left: paso(), behavior: reduce ? 'auto' : 'smooth' }); setTimeout(estado, 450); });
      pista.addEventListener('scroll', estado, { passive: true });
      window.addEventListener('resize', estado, { passive: true });
      estado();
    });
  }

  /* ---------------------------------------------------------
     Banner principal (carrusel de ofertas con puntos y auto)
     --------------------------------------------------------- */
  function initBanners() {
    document.querySelectorAll('[data-mt-banner]:not([data-mt-ready])').forEach(function (raiz) {
      raiz.setAttribute('data-mt-ready', '1');
      var pista = raiz.querySelector('.mt-banner__pista');
      if (!pista) return;
      var slides = pista.querySelectorAll('.mt-banner__slide');
      if (slides.length < 2) return;

      var puntos = raiz.querySelectorAll('.mt-banner__punto');
      var prev = raiz.querySelector('.mt-banner__nav--prev');
      var next = raiz.querySelector('.mt-banner__nav--next');
      var segundos = parseFloat(raiz.getAttribute('data-mt-auto')) || 0;
      var actual = 0;
      var timer = null;

      function ir(i, suave) {
        actual = (i + slides.length) % slides.length;
        pista.scrollTo({ left: pista.clientWidth * actual, behavior: (suave && !reduce) ? 'smooth' : 'auto' });
        pintar();
      }
      function pintar() {
        puntos.forEach(function (p, i) { p.setAttribute('aria-current', i === actual ? 'true' : 'false'); });
      }
      function arrancar() {
        if (!segundos || reduce) return;
        parar();
        timer = setInterval(function () { ir(actual + 1, true); }, segundos * 1000);
      }
      function parar() { if (timer) { clearInterval(timer); timer = null; } }

      if (prev) prev.addEventListener('click', function () { ir(actual - 1, true); arrancar(); });
      if (next) next.addEventListener('click', function () { ir(actual + 1, true); arrancar(); });
      puntos.forEach(function (p, i) { p.addEventListener('click', function () { ir(i, true); arrancar(); }); });

      pista.addEventListener('scroll', function () {
        var i = Math.round(pista.scrollLeft / Math.max(pista.clientWidth, 1));
        if (i !== actual) { actual = i; pintar(); }
      }, { passive: true });

      raiz.addEventListener('mouseenter', parar);
      raiz.addEventListener('mouseleave', arrancar);
      window.addEventListener('resize', function () { ir(actual, false); }, { passive: true });

      pintar();
      arrancar();
    });
  }

  /* ---------------------------------------------------------
     Página de producto: galería, cantidad y variantes
     --------------------------------------------------------- */
  function initProducto() {
    document.querySelectorAll('[data-mt-producto]:not([data-mt-ready])').forEach(function (raiz) {
      raiz.setAttribute('data-mt-ready', '1');

      /* Galería: miniaturas cambian la imagen principal */
      var principal = raiz.querySelector('[data-mt-principal]');
      var minis = raiz.querySelectorAll('[data-mt-mini]');
      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-mt-src');
          if (!src || !principal) return;
          principal.src = src;
          minis.forEach(function (m) { m.setAttribute('aria-current', m === mini ? 'true' : 'false'); });
        });
      });

      /* Cantidad */
      var campo = raiz.querySelector('[data-mt-cantidad]');
      var menos = raiz.querySelector('[data-mt-menos]');
      var mas = raiz.querySelector('[data-mt-mas]');
      function ajustar(delta) {
        if (!campo) return;
        var n = parseInt(campo.value, 10);
        if (isNaN(n)) n = 1;
        n = Math.max(1, n + delta);
        campo.value = n;
      }
      if (menos) menos.addEventListener('click', function () { ajustar(-1); });
      if (mas) mas.addEventListener('click', function () { ajustar(1); });

      /* Botón "Pagar con Yape o Plin": rehace el mensaje de WhatsApp
         con la cantidad y el precio que hay en pantalla en ese momento */
      var btnYape = raiz.querySelector('[data-mt-pagar-yape]');
      function refrescarYape() {
        if (!btnYape) return;
        var numero = btnYape.getAttribute('data-mt-wa-numero');
        var plantilla = btnYape.getAttribute('data-mt-wa-plantilla') || '';
        var cant = campo ? (parseInt(campo.value, 10) || 1) : 1;
        var elP = raiz.querySelector('[data-mt-precio]');
        var precio = elP ? elP.textContent.trim() : '';
        var texto = plantilla.replace('__CANT__', cant).replace('__PRECIO__', precio);
        btnYape.href = 'https://wa.me/' + numero + '?text=' + encodeURIComponent(texto);
      }
      refrescarYape();
      if (campo) campo.addEventListener('change', refrescarYape);
      if (menos) menos.addEventListener('click', refrescarYape);
      if (mas) mas.addEventListener('click', refrescarYape);

      /* Botón "Pagar con tarjeta": añade al carrito y va directo a pagar */
      var btnTarjeta = raiz.querySelector('[data-mt-pagar-tarjeta]');
      if (btnTarjeta) {
        btnTarjeta.addEventListener('click', function () {
          var campoId = raiz.querySelector('[data-mt-id]');
          if (!campoId) return;
          var etiqueta = btnTarjeta.querySelector('span');
          var textoOriginal = etiqueta ? etiqueta.textContent : '';
          btnTarjeta.disabled = true;
          if (etiqueta) etiqueta.textContent = 'Un momento…';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: Number(campoId.value),
                quantity: campo ? (parseInt(campo.value, 10) || 1) : 1
              }]
            })
          })
            .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, datos: d }; }); })
            .then(function (res) {
              if (!res.ok) throw new Error(res.datos.description || res.datos.message || 'No se pudo añadir');
              window.location.href = '/checkout';
            })
            .catch(function (e) {
              btnTarjeta.disabled = false;
              if (etiqueta) etiqueta.textContent = textoOriginal;
              alert('No pudimos continuar con el pago: ' + e.message + '\n\nPrueba con "Agregar al carrito".');
            });
        });
      }

      /* Variantes */
      var datos = raiz.querySelector('[data-mt-variantes]');
      if (!datos) return;
      var variantes;
      try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
      if (!variantes || !variantes.length) return;

      var campoId  = raiz.querySelector('[data-mt-id]');
      var elPrecio = raiz.querySelector('[data-mt-precio]');
      var elAntes  = raiz.querySelector('[data-mt-antes]');
      var elAhorro = raiz.querySelector('[data-mt-ahorro]');
      var elStock  = raiz.querySelector('[data-mt-stock]');
      var elBadge  = raiz.querySelector('[data-mt-badge]');
      var btnAdd   = raiz.querySelector('[data-mt-add]');
      var txtAdd   = raiz.querySelector('[data-mt-add-texto]');
      var textoBoton   = txtAdd ? txtAdd.textContent.trim() : 'Agregar al carrito';
      var textoAgotado = elStock ? elStock.getAttribute('data-mt-agotado') : null;

      function seleccion() {
        var vals = [];
        raiz.querySelectorAll('[data-mt-opcion]').forEach(function (b) {
          if (b.getAttribute('aria-checked') === 'true') {
            vals[parseInt(b.getAttribute('data-mt-opcion'), 10)] = b.getAttribute('data-mt-valor');
          }
        });
        return vals;
      }

      function aplicar() {
        var vals = seleccion();
        var encontrada = null;
        for (var i = 0; i < variantes.length; i++) {
          var v = variantes[i];
          var coincide = true;
          for (var j = 0; j < vals.length; j++) {
            if (vals[j] !== undefined && v.opciones[j] !== vals[j]) { coincide = false; break; }
          }
          if (coincide) { encontrada = v; break; }
        }
        if (!encontrada) return;

        if (campoId) campoId.value = encontrada.id;
        if (elPrecio) elPrecio.textContent = encontrada.precio;

        if (elAntes) {
          if (encontrada.antes) { elAntes.textContent = encontrada.antes; elAntes.hidden = false; }
          else { elAntes.textContent = ''; elAntes.hidden = true; }
        }
        if (elAhorro) {
          if (encontrada.ahorro) { elAhorro.textContent = 'Ahorras ' + encontrada.ahorro + '%'; elAhorro.hidden = false; }
          else { elAhorro.textContent = ''; elAhorro.hidden = true; }
        }
        if (elBadge) {
          if (encontrada.ahorro) { elBadge.textContent = '-' + encontrada.ahorro + '%'; elBadge.hidden = false; }
          else { elBadge.hidden = true; }
        }
        if (encontrada.imagen && principal) {
          principal.src = encontrada.imagen;
          minis.forEach(function (m) {
            m.setAttribute('aria-current', m.getAttribute('data-mt-src') === encontrada.imagen ? 'true' : 'false');
          });
        }
        if (btnAdd) {
          btnAdd.disabled = !encontrada.disponible;
          if (txtAdd) txtAdd.textContent = encontrada.disponible ? textoBoton : (textoAgotado || 'Agotado');
        }
        if (elStock) {
          elStock.classList.toggle('mt-pdp__stock--no', !encontrada.disponible);
          var t = encontrada.disponible
            ? elStock.getAttribute('data-mt-disponible')
            : elStock.getAttribute('data-mt-agotado');
          if (t) elStock.textContent = t;
        }
        if (btnTarjeta) btnTarjeta.disabled = !encontrada.disponible;
        refrescarYape();
      }

      raiz.querySelectorAll('[data-mt-opcion]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var grupo = btn.closest('.mt-pdp__valores');
          if (grupo) {
            grupo.querySelectorAll('[data-mt-valor]').forEach(function (b) {
              b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
            });
          }
          aplicar();
        });
      });
    });
  }

  /* Enlaces de WhatsApp: NO se tocan desde JS.
     El propio <a target="_blank" rel="noopener noreferrer"> ya abre una
     pestaña nueva y deja intacta la página actual.
     Aviso para el futuro: window.open(url, '_blank', 'noopener') devuelve
     null AUNQUE la ventana se abra bien (es lo que marca el estándar). Si
     se usa ese null como "no se pudo abrir" y se navega de plan B, el
     usuario acaba con la pestaña nueva Y la página recargada. Pasó. */

  function boot() { initReveal(); initCarruseles(); initBanners(); initProducto(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* El editor de Shopify recarga secciones sueltas: rearmamos */
  document.addEventListener('shopify:section:load', boot);
})();
